import script from "./App.vue?vue&type=script&setup=true&lang=js"
export * from "./App.vue?vue&type=script&setup=true&lang=js"

import "./assets/css/bootstrap.min.css?vue&type=style&index=0&lang=css&external"
import "./assets/css/myshortcut.css?vue&type=style&index=1&lang=css&external"

const __exports__ = script;

export default __exports__